var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "modal",
        { staticClass: "agreement-modal solid" },
        [
          _vm.loading
            ? _c("loader")
            : _vm.content
            ? _c("div", {
                staticClass: "agreement-modal-content",
                domProps: { innerHTML: _vm._s(_vm.content) }
              })
            : _c("h3", { staticClass: "agreement-modal-error" }, [
                _vm._v("The agreement is not available")
              ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d92a239", { render: render, staticRenderFns: staticRenderFns })
  }
}